import React, { useState } from "react";
import { Button, Image, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom"; // ⬅️ React Router para redirección
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import ImagenLogin from "../Assets/draw2.webp";
import { MDBContainer, MDBCol, MDBRow, MDBInput } from "mdb-react-ui-kit";
import Footer from "../components/Footer";

function LoginAdmin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const auth = getAuth();

  const handleLogin = async () => {
    setLoading(true);
    setError(null);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard"); // ⬅️ Redirección segura con React Router
    } catch (error) {
      setError("Correo o contraseña incorrectos. Intenta nuevamente.");
      console.error("Error en login:", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <MDBContainer fluid className="p-3 my-5 h-custom">
        <MDBRow>
          <MDBCol col="10" md="6">
            <Image src={ImagenLogin} fluid />
          </MDBCol>
          <MDBCol col="4" md="6">
            <div className="divider d-flex align-items-center my-4">
              <h1 className="text-center fw-bold mx-3 mb-0">LOGIN</h1>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            <MDBInput
              wrapperClass="mb-4"
              label="Usuario"
              type="email"
              size="lg"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
            <MDBInput
              wrapperClass="mb-4"
              label="Contraseña"
              type="password"
              size="lg"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />

            <div className="d-grid gap-1">
              <Button variant="dark" size="lg" onClick={handleLogin} disabled={loading}>
                {loading ? "Ingresando..." : "Ingresar"}
              </Button>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <Footer />
    </>
  );
}

export default LoginAdmin;
